import { XCircleIcon } from '@heroicons/react/20/solid';

export interface SuccessAlertProps {
  text: string;
}

export const ErrorAlert = (props: SuccessAlertProps) => {
  return (
    <div className="rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="shrink-0">
          <XCircleIcon aria-hidden="true" className="size-5 text-red-400" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-red-800">{props.text}</p>
        </div>
      </div>
    </div>
  );
};
